/* template */
<template minapp="mpx" xlang="wxml"><div class="falling-popup-container"><es-popup :show="(fallingSwitch)" @close="closeFalling"><div :style="[(panelStyle)] | transRpxStyle" class="panel-container"><div class="panel-header"><mpx-image mode="aspectFill" :src="(headerImage)" class="panel-header-image"/></div><div :style="[(panelContentStyle)] | transRpxStyle" class="panel-content"><coupon-list :listData="(listData)" :couponTheme="(couponTheme)"/></div><div :style="[(panelFooterStyle)] | transRpxStyle" class="panel-footer"><coupon-btn :buttonTheme="(buttonTheme)" @receiveFallingCoupon="receiveFallingCoupon"/></div></div><mpx-image @tap="closeFalling" :src="(closeIcon)" class="close-icon"/></es-popup></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m2960665a"}'>
  .panel-container
    width 260px
    max-height 314px
    border-radius 28px
    position relative
    overflow hidden
    background-size cover
    background-repeat repeat
    background-position center
    .panel-header
      height 64px
      .panel-header-image
        width 100%
        height 100%
    .panel-content
      max-height 180px
      overflow-y auto
    .panel-footer
      height 70px
      display flex
      justify-content center
      align-items center
      overflow hidden
  .close-icon
    width 36px
    height 36px
    margin 20px 0 0 calc(260px / 2 - 36px / 2)
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m2960665a"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex2960665a%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex2960665a%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m2960665a"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index2960665a/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'coupon-btn':getComponent(require("./coupon-btn.mpx?isComponent&outputPath=components%2Fcoupon-btnf92ddf4a%2Findex")),'coupon-list':getComponent(require("./coupon-list.mpx?isComponent&outputPath=components%2Fcoupon-list8233ada6%2Findex")),'es-popup':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/popup/index.mpx?isComponent&outputPath=components%2Findex9216a4d4%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
